<section class="quotation-objective">
    <p>{{ 'buyer.create-quotation.quotation-objective.header.title' | translate }}</p>
    <form class="content form-check radio-group" [formGroup]="objectiveFormGroup">
        <div>
            <input type="radio" id="isPurchaseTrue" name="isPurchase" [value]="true" formControlName="isPurchase"/>
            <label for="isPurchaseTrue">{{ 'buyer.create-quotation.quotation-objective.form.objective-radio.buy' | translate }}</label>
        </div>
        <div>
            <input type="radio" id="isPurchaseFalse" name="isPurchase" [value]="false" formControlName="isPurchase"/>
            <label for="isPurchaseFalse">{{ 'buyer.create-quotation.quotation-objective.form.objective-radio.not-buy' | translate }}</label>
        </div>
    </form>
</section>
